import { configureStore, isRejectedWithValue } from "@reduxjs/toolkit";
import { apiWithAuth } from "./features/api/apiWithAuth";
import { apiWithoutAuth } from "./features/api/apiWithoutAuth";
import { categoryApi } from "./features/api/categoryApi";
import { clinicAuth } from "./features/api/clinicAuth";
import { doctorsApi } from "./features/api/doctorsApi";
import authReducer from "./features/auth/authSlice";
import { servicesApi } from "./features/api/servicesAPi";
import { ReceptionistAPI } from "./features/api/receptionist";
import { patientsApi } from "./features/api/patient";
import { appointmentsApi } from "./features/api/appointmentsApi";
import { medicalReportApi } from "./features/api/medicalReportApi";
import { taxApi } from "./features/api/taxApi";
import { billingApi } from "./features/api/billingApi";
import { doctorEarningApi } from "./features/api/doctorEarningApi";
import { doctorPayoutApi } from "./features/api/doctorPayoutApi";
import adminAuthReducer from "./features/admin/adminAuthSlice";
import { prescriptionApi } from "./features/api/prescription";
import { adminSaasApi } from "./features/api/adminSaasApi";
import { subscriptionApi } from "./features/api/subscriptionApi";
import { activityApi } from "./features/api/activityApi";
import { internalChatApi } from "./features/api/internalChatApi";
import { pharmacyInventoryApi } from "./features/api/pharmacyInventoryApi";
import { logout } from "./features/auth/authSlice";
import { clearAdminCredentials } from "./features/admin/adminAuthSlice";

const redirectToLogin = (path) => {
  if (typeof window === "undefined") return;
  if (window.location.pathname === path) return;
  window.location.replace(path);
};

const authExpiredMiddleware = (storeApi) => (next) => (action) => {
  if (isRejectedWithValue(action) && action.payload?.status === 401) {
    const isAdminArea =
      typeof window !== "undefined" &&
      window.location.pathname.startsWith("/admin");

    if (isAdminArea) {
      storeApi.dispatch(clearAdminCredentials());
      redirectToLogin("/admin/login");
    } else {
      storeApi.dispatch(logout());
      redirectToLogin("/login");
    }
  }

  return next(action);
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [apiWithAuth.reducerPath]: apiWithAuth.reducer,
    [apiWithoutAuth.reducerPath]: apiWithoutAuth.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [clinicAuth.reducerPath]: clinicAuth.reducer,
    [doctorsApi.reducerPath]: doctorsApi.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
    [ReceptionistAPI.reducerPath]: ReceptionistAPI.reducer,
    [patientsApi.reducerPath]: patientsApi.reducer,
    [appointmentsApi.reducerPath]: appointmentsApi.reducer,
    [medicalReportApi.reducerPath]: medicalReportApi.reducer,
    [taxApi.reducerPath]: taxApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [doctorEarningApi.reducerPath]: doctorEarningApi.reducer,
    [doctorPayoutApi.reducerPath]: doctorPayoutApi.reducer,
    [prescriptionApi.reducerPath]: prescriptionApi.reducer,
    [adminSaasApi.reducerPath]: adminSaasApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [activityApi.reducerPath]: activityApi.reducer,
    [internalChatApi.reducerPath]: internalChatApi.reducer,
    [pharmacyInventoryApi.reducerPath]: pharmacyInventoryApi.reducer,
    adminAuth: adminAuthReducer,
    // [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authExpiredMiddleware,
      apiWithAuth.middleware,
      apiWithoutAuth.middleware,
      categoryApi.middleware,
      clinicAuth.middleware,
      doctorsApi.middleware,
      servicesApi.middleware,
      ReceptionistAPI.middleware,
      patientsApi.middleware,
      appointmentsApi.middleware,
      medicalReportApi.middleware,
      taxApi.middleware,
      billingApi.middleware,
      doctorEarningApi.middleware,
      doctorPayoutApi.middleware,
      prescriptionApi.middleware,
      adminSaasApi.middleware,
      subscriptionApi.middleware,
      activityApi.middleware,
      internalChatApi.middleware,
      pharmacyInventoryApi.middleware,
      // adminApi.middleware,
    ),
});
